import type { ReactNode } from 'react';
import { Navigate } from 'react-router';
import { useOnboardingGuard } from '@/hooks/useOnboardingGuard';
import { Skeleton } from '@/components/ui/skeleton';

interface RequireOnboardingProps {
  children: ReactNode;
}

export function RequireOnboarding({ children }: RequireOnboardingProps) {
  const { isOnboarded, loading } = useOnboardingGuard();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center">
        <div className="w-64 space-y-4">
          <Skeleton className="h-8 w-3/4" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-full" />
          <Skeleton className="h-4 w-1/2" />
        </div>
      </div>
    );
  }

  if (!isOnboarded) {
    return <Navigate to="/onboarding" replace />;
  }

  return <>{children}</>;
}
